import { useState, useEffect, useRef } from 'react';
import './index.css';

const Index = (props: any) => {
    const [showPassword, setShowPassword] = useState(false);
    const isPassword = props.type === 'password';
    const isSecureText = props.secureText === true;

    useEffect(() => {
        return () => {
            // alert('destroy component');
            if (props.onChange) {
                props.onChange({
                    target: {
                        id: props.id,
                        value: ''
                    }
                });
            }
        };
    }, []);
    return (
        <div className="form-input">
            {props.type == 'textarea' ? (
                <textarea
                    id={props.id}
                    rows="4"
                    cols="50"
                    className={'custom custom-text w-100 ' + props.className}
                    value={props.value}
                    onChange={({ target }) => {
                        if (props.onChange) {
                            props.onChange({ target });
                        }
                    }}
                />
            ) : isPassword || isSecureText ? (
                <div style={{ position: 'relative' }}>
                    <input
                        id={props.id}
                        className={'custom custom-text ' + props.className}
                        type={isSecureText ? 'text' : showPassword ? 'text' : 'password'}
                        style={
                            isSecureText
                                ? { ...props.style, WebkitTextSecurity: showPassword ? 'none' : 'disc' }
                                : props.style
                        }
                        autoComplete={props.autoComplete}
                        value={props.value}
                        onChange={({ target }) => {
                            if (props.onChange) {
                                props.onChange({ target });
                            }
                        }}
                    />
                    <span
                        onClick={() => setShowPassword((prev) => !prev)}
                        style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            userSelect: 'none'
                        }}
                    >
                        <i
                            className={showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'}
                            aria-hidden="true"
                        ></i>
                    </span>
                </div>
            ) : (
                <input
                    id={props.id}
                    className={'custom custom-text ' + props.className}
                    type={props.type || 'text'}
                    inputMode={props.inputMode}
                    autoComplete={props.autoComplete}
                    style={props.style}
                    value={props.value}
                    onChange={({ target }) => {
                        if (props.onChange) {
                            props.onChange({ target });
                        }
                    }}
                />
            )}

            <div className="input-error">{props.error || ''}</div>
        </div>
    );
};

export default Index;
